export default __webpack_public_path__ + "static/media/discount.9e8218bc.svg";